export function stripHtmlTags(html: string): string {
  if (!html) return ''

  return (
    html
      // Replace <p> and </p> with newlines (ensure double newlines for paragraph separation)
      .replace(/<\/p>\s*<p[^>]*>/gi, '\n\n')
      .replace(/<p[^>]*>/gi, '') // remove opening <p>
      .replace(/<\/p>/gi, '\n\n') // ensure paragraph break

      // Replace <br> or <br/> with single newlines
      .replace(/<br\s*\/?>/gi, '\n')

      // Remove all other tags
      .replace(/<[^>]+>/g, '')

      // Normalize multiple newlines
      .replace(/\n{3,}/g, '\n\n')

      // Trim start and end whitespace/newlines
      .trim()
  )
}
